import { ResponsiveValue } from 'styled-system';

function isPrimitive(val: any) {
  return val !== Object(val);
}

export function convertResponsiveValue<T, K>(
  responsiveVal: ResponsiveValue<T>,
  converter: (val: T | null) => K,
): ResponsiveValue<K> {
  if (Array.isArray(responsiveVal)) {
    return responsiveVal.map(converter);
  } else if (isPrimitive(responsiveVal)) {
    return converter(responsiveVal as T);
  } else {
    return Object.keys(responsiveVal).reduce<Record<string, K>>((acc, key) => {
      acc[key] = converter((responsiveVal as Record<string, T>)[key]);
      return acc;
    }, {});
  }
}

export function convertToTileWidth(tilesPerRow: ResponsiveValue<number>): ResponsiveValue<number> {
  const converter = (tileCount: number | null) => (tileCount === null ? 2 : 1 / tileCount);
  return convertResponsiveValue(tilesPerRow, converter);
}
